import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Container, Grid, Card, CardMedia, Typography, TextField, Box, Dialog, DialogTitle, DialogContent, Button, Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import { db, collection, getDocs } from '../firebase';
import { Link, useLocation } from 'react-router-dom';
import debounce from 'lodash.debounce';
import iconB from '../assets/bot_4712139.png';


const ItemPresentation = () => {
  const [items, setItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubcategory, setSelectedSubcategory] = useState('');
  const [openImage, setOpenImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const location = useLocation();
  const [animate, setAnimate] = useState(false);


  useEffect(() => {
    fetchItems();
  }, []);

  const handleButtonClick = () => {
    setAnimate(true);
    setTimeout(() => setAnimate(false), 300);
  };

  const fetchItems = async () => {
    const itemsCollection = await getDocs(collection(db, 'items'));
    const itemsData = itemsCollection.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setItems(itemsData);
  };

  const handleSearchChange = useCallback(debounce((e) => {
    setSearchTerm(e.target.value);
  }, 300), []);

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
    setSelectedSubcategory(''); // Reset subcategory when category changes
  };

  const handleSubcategoryChange = (e) => {
    setSelectedSubcategory(e.target.value);
  };



  const getCategorySet = (items) => {
    const categories = new Set();
    items.forEach(item => {
      item.category.split(',').forEach(cat => categories.add(cat.trim()));
    });
    return Array.from(categories);
  };


  const filteredItems = useMemo(() => {
    return items.filter(item => {
      const itemCategories = item.category.split(',').map(cat => cat.trim());
      return (item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.serialNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
        itemCategories.some(cat => cat.toLowerCase().includes(searchTerm.toLowerCase())) ||
        item.subcategory1.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.subcategory2.toLowerCase().includes(searchTerm.toLowerCase())) &&
        (selectedCategory ? itemCategories.includes(selectedCategory) : true) &&
        (selectedSubcategory ? item.subcategory1 === selectedSubcategory : true);
    });
  }, [items, searchTerm, selectedCategory, selectedSubcategory]);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setOpenImage(true);
  };

  const handleCloseImage = () => {
    setOpenImage(false);
    setSelectedImage('');
  };


  return (
    <Container sx={{ paddingTop: '20px', backgroundColor: 'transparent' }}>
       <Box style={{ display: 'flex', justifyContent: 'flex-start' }}>
        <Button
          component={Link}
          to={location.pathname === '/chat_m' ? '/chat_m' : '/chat_m'}
          onClick={handleButtonClick}
          sx={{
            display: 'flex',
            flexDirection: 'column', // Change to column to stack items
            alignItems: 'center',
            textDecoration: 'none',
            borderRadius: '30px',
            backgroundColor: 'transparent',
            flexGrow: 1,
            justifyContent: 'center', // Center items vertically
            width: '20%', // Half of the parent width
          }}
        >
          <img
            src={iconB}
            alt="Icon 2"
            style={{
              width: '45px',
              height: '45px',
              border: 'solid 2px black',
              borderRadius: '30px',
              marginBottom: '8px', // Add some space between the image and text
            }}
          />
          חזרה
        </Button>
      </Box>

      <FormControl fullWidth sx={{ marginBottom: '10px' }}>
        <InputLabel id="category-select-label">בחר קטגוריה</InputLabel>
        <Select
          labelId="category-select-label"
          value={selectedCategory}
          onChange={handleCategoryChange}
          label="בחר קטגוריה"
        >
          <MenuItem value=""><em>הכל</em></MenuItem>
          {getCategorySet(items).map(category => (
            <MenuItem key={category} value={category}>{category}</MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* {selectedCategory && ( */}
      <FormControl disabled={!selectedCategory} fullWidth sx={{ marginBottom: '20px' }}>
        <InputLabel id="subcategory-select-label">בחר תת-קטגוריה</InputLabel>
        <Select
          labelId="subcategory-select-label"
          value={selectedSubcategory}
          onChange={handleSubcategoryChange}
          label="בחר תת-קטגוריה"
        >
          <MenuItem value=""><em>הכל</em></MenuItem>
          {Array.from(new Set(items.filter(item => item.category.includes(selectedCategory)).map(item => item.subcategory1))).map(subcategory => (
            <MenuItem key={subcategory} value={subcategory}>{subcategory}</MenuItem>
          ))}
        </Select>
      </FormControl>
      {/* )} */}

      <TextField
        variant="outlined"
        fullWidth
        label='חפש פריט לפי שם \ מק"ט \ קטגוריה \ תיאור'
        onChange={handleSearchChange}
        sx={{ marginBottom: '20px' }}
      />

      <div style={{ maxHeight: '40vh', overflowY: 'auto', overflowX: 'hidden', border: 'solid 1px #b1b1a5', borderRadius: '5px' }}>
        <Grid container spacing={2}>
          {filteredItems.map(item => (
            <Grid item xs={12} sm={6} md={4} key={item.id}>
              <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <Card sx={{ width: '120px', height: '120px', borderRadius: '50%', overflow: 'hidden', marginRight: '20px', marginLeft: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <CardMedia
                    component="img"
                    alt={item.name}
                    image={item.image}
                    sx={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                    onClick={() => handleImageClick(item.image)}
                  />
                </Card>
                <Box sx={{ marginLeft: '10px' }}>
                  <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#333', fontSize: '0.9em' }}>{item.name.substring(0, 20)}</Typography>
                  <Typography variant="body2" sx={{ color: '#777' }}> מק"ט : <span id='red'> {item.serialNumber}</span></Typography>
                  <Typography variant="body2" sx={{ color: '#777' }}>  קטגוריה : <span id='blue'>{item.category}</span> </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </div>
      <Dialog open={openImage} onClose={handleCloseImage} maxWidth="lg">
        <DialogTitle>Image</DialogTitle>
        <DialogContent>
          <img src={selectedImage} alt="Large View" style={{ width: '100%', height: 'auto' }} />
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default ItemPresentation;
